import AUTOMATION_TOOLS from "./automations"
import TABLE_TOOLS from "./tables"
import ROW_TOOLS from "./rows"
export default [...AUTOMATION_TOOLS, ...TABLE_TOOLS, ...ROW_TOOLS]
